import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import AuthLoading from '../pages/AuthLoading';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { status } = useContext(AuthContext);
  const location = useLocation();
  if (status === 'authenticated') return <>{children}</>;
  if (status === 'anonymous' || status === 'reauthentication_required') {
    return <Navigate to="/login" replace state={{ returnTo: `${location.pathname}${location.search}` }} />;
  }
  return <AuthLoading />;
}

export { PrivateRoute };
